var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5844 10.1045C10.6091 9.90711 10.6276 9.70972 10.6276 9.5C10.6276 9.29028 10.6091 9.09289 10.5844 8.89551L11.8859 7.87773C12.0031 7.78521 12.034 7.61866 11.96 7.48296L10.7263 5.34872C10.6523 5.21302 10.4857 5.16367 10.35 5.21302L8.81412 5.82985C8.49336 5.58312 8.14794 5.37956 7.77167 5.22536L7.53727 3.59075C7.51877 3.44271 7.38923 3.33168 7.23503 3.33168H4.7677C4.61349 3.33168 4.48396 3.44271 4.46545 3.59075L4.23105 5.22536C3.85479 5.37956 3.50936 5.58929 3.18861 5.82985L1.6527 5.21302C1.51083 5.1575 1.35045 5.21302 1.27643 5.34872L0.0427659 7.48296C-0.0374222 7.61866 -0.000412286 7.78521 0.116786 7.87773L1.4183 8.89551C1.39363 9.09289 1.37512 9.29645 1.37512 9.5C1.37512 9.70355 1.39363 9.90711 1.4183 10.1045L0.116786 11.1223C-0.000412286 11.2148 -0.0312539 11.3813 0.0427659 11.517L1.27643 13.6513C1.35045 13.787 1.51699 13.8363 1.6527 13.787L3.18861 13.1701C3.50936 13.4169 3.85479 13.6204 4.23105 13.7746L4.46545 15.4092C4.48396 15.5573 4.61349 15.6683 4.7677 15.6683H7.23503C7.38923 15.6683 7.51877 15.5573 7.53727 15.4092L7.77167 13.7746C8.14794 13.6204 8.49336 13.4107 8.81412 13.1701L10.35 13.787C10.4919 13.8425 10.6523 13.787 10.7263 13.6513L11.96 11.517C12.034 11.3813 12.0031 11.2148 11.8859 11.1223L10.5844 10.1045V10.1045ZM6.00138 11.6589C4.81089 11.6589 3.84247 10.6905 3.84247 9.5C3.84247 8.30951 4.81089 7.34108 6.00138 7.34108C7.19187 7.34108 8.16029 8.30951 8.16029 9.5C8.16029 10.6905 7.19187 11.6589 6.00138 11.6589V11.6589Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.2774c01b.svg";
export { ForwardRef as ReactComponent };